import Utils from './Utils';

export default class HexGrid {
	constructor() {
		this.DOM = {
			el: document.querySelector('[data-hex="grid"]')
		};

		this.results = { seibutsu: 0, shokuhin: 0, idenshi: 0, iyo: 0, seimei: 0, ningen: 0 };
		this.opts = [
			{ name: 'shokubutsu', scores: { seibutsu: 3, shokuhin: 1 } },
			{ name: 'biseibutsu', scores: { seibutsu: 1, idenshi: 1, shokuhin: 2, iyo: 1 } },
			{ name: 'nogyo', scores: { seibutsu: 2, shokuhin: 1 } },
			{ name: 'shokuryo', scores: { seibutsu: 1 } },
			{ name: 'chikusan', scores: { idenshi: 1 } },
			{ name: 'saibo', scores: { seibutsu: 1, idenshi: 3, shokuhin: 1 } },
			{ name: 'seishoku', scores: { idenshi: 2 } },
			{ name: 'seibutsukino', scores: { idenshi: 1 } },
			{ name: 'kinoseishokuhin', scores: { seibutsu: 1, shokuhin: 2 } },
			{ name: 'shokuhineisei', scores: { shokuhin: 2 } },
			{ name: 'programming', scores: { seimei: 3 } },
			{ name: 'robot', scores: { seimei: 1, ningen: 1 } },
			{ name: 'jinkouchinou', scores: { seimei: 1, iyo: 1 } },
			{ name: 'soukishindan', scores: { idenshi: 1, seimei: 2, iyo: 1 } },
			{ name: 'soyaku', scores: { seibutsu: 1, idenshi: 1, shokuhin: 1, seimei: 1, iyo: 1 } },
			{ name: 'sports', scores: { ningen: 1 } },
			{ name: 'jukankyo', scores: { ningen: 2 } },
			{ name: 'proddesign', scores: { ningen: 2 } },
			{ name: 'fukushi', scores: { ningen: 1, iyo: 1 } },
			{ name: 'hikari', scores: { seimei: 1, ningen: 1 } },
			{ name: 'onkyo', scores: { seimei: 1, ningen: 1 } },
			{ name: 'iryokiki', scores: { iyo: 3 } },
			{ name: 'biomaterial', scores: { ningen: 1, iyo: 1 } },
			{ name: 'nanotech', scores: { iyo: 1 } }
		];

		this.selectedEls = [];
		this.maxResults = 3;
		this.isMobile = window.innerWidth < 860;

		this.onLabelClick = this.onLabelClick.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
		this.onResetClick = this.onResetClick.bind(this);
		this.onCloseClick = this.onCloseClick.bind(this);
	}

	init() {
		if (!this.DOM.el) return;
		this.removeCells();
		this.getChildren();
		this.bindEvents();
	}

	// Remove excessive cells on mobile
	removeCells() {
		if (!this.isMobile) return;
		const removeList = document.querySelectorAll('.s-hex--hide');
		removeList.forEach(el => el.parentNode.removeChild(el))
	}

	getChildren() {
		this.DOM.labelEls = Array.from(this.DOM.el.querySelectorAll('label'));
		this.DOM.submitEl = document.querySelector('[data-hex="submit"]');
		this.DOM.resetEl = document.querySelector('[data-hex="reset"]');
		this.DOM.closeEl = document.querySelector('[data-hex="close"]');
		this.DOM.modal = document.querySelector('.s-gridmodal');
		this.DOM.modalItems = this.DOM.modal.querySelectorAll('.s-gridmodal__item');
	}

	bindEvents() {
		this.DOM.labelEls.forEach(el => el.addEventListener('click', this.onLabelClick));
		this.DOM.submitEl.addEventListener('click', this.onSubmitClick);
		this.DOM.resetEl.addEventListener('click', this.onResetClick);
		this.DOM.closeEl.addEventListener('click', this.onCloseClick);
	}

	onLabelClick(e) {
		const el = e.currentTarget;
		const name = el.getAttribute('for');
		const isSelected = el.classList.contains('is-selected');
		const index = this.selectedEls.indexOf(el);

		if (this.selectedEls.length < this.maxResults && !isSelected) {
			this.selectedEls.push(el);
			el.classList.add('is-selected');
		}
		else if (isSelected) {
			this.selectedEls.splice(index, 1);
			el.classList.remove('is-selected');
		}
		else {
			this.selectedEls[0].classList.remove('is-selected');
			this.selectedEls.splice(0, 1);
			el.classList.add('is-selected');
			this.selectedEls.push(el);
		}

		const selectedMax = this.selectedEls.length === this.maxResults;

		if (selectedMax) {
			const submitElOffset = Utils.getOffset(this.DOM.submitEl) + this.DOM.submitEl.offsetHeight - window.innerHeight;
			window.scrollTo({ top: submitElOffset + 10, behavior: 'smooth' });
		}

		this.DOM.submitEl.classList.toggle('g-btn--disabled', !selectedMax);
	}

	onSubmitClick(e) {
		e.preventDefault();
		if (this.selectedEls.length !== this.maxResults) return;

		// Add scores
		this.selectedEls.forEach(el => {
			const labelName = el.getAttribute('for');

			for (let [key, value] of Object.entries(this.opts)) {
				if (labelName === value.name) {
					for (let [name, score] of Object.entries(value.scores)) {
						this.results[name] += score;
					}
				}
			}
		});

		// Sort scores from highest to lowest and remove zeros
		let sortedScoreArray = [];

		for (let res in this.results) {
			sortedScoreArray.push([res, this.results[res]]);
		}

		sortedScoreArray = sortedScoreArray.sort((a, b) => b[1] - a[1]).filter(item => item[1] > 0);

		// Build two-dimensional array of items with same score
		const maxScore = sortedScoreArray[0][1];
		let sameScoreArray = [];

		for (let i = maxScore; i >= 0; i--) {
			let arr = [];
			sortedScoreArray.forEach(item => item[1] === i && arr.push(item));
			arr.length && sameScoreArray.push(arr);
		}

		// If all scores are the same, show them in random order
		if (sameScoreArray.length === 1) {
			sameScoreArray = [Utils.shuffleArray(sameScoreArray[0])];
		}

		let resultArray = [];

		resultArray = resultArray.concat(sameScoreArray[0]);

		// if (sameScoreArray[1]) {
		// 	resultArray = resultArray.concat(sameScoreArray[1]);
		// }

		if (sameScoreArray[1]) {
			if (sameScoreArray[1].length >= 2) {
				resultArray = resultArray.concat(Utils.shuffleArray(sameScoreArray[1]));
			}
			else {
				resultArray = resultArray.concat(sameScoreArray[1]);
			}
		}


		// Choose random item from items with lowest score
		if (sameScoreArray[2]) {
			resultArray.push(sameScoreArray[2][Math.floor(Math.random() * sameScoreArray[2].length)]);
		}

		this.showModal(resultArray);
	}

	showModal(resultArray) {
		const maxLength = resultArray.length >= this.maxResults ? this.maxResults : resultArray.length;

		this.DOM.modalItems.forEach(el => {
			el.style.display = 'none';
			// Show maximum three elements with classname
			// corresponding to three highest scores
			for (let i = 0; i < maxLength; i++) {
				if (el.classList.contains(resultArray[i][0])) {
					el.style.display = 'block';
					el.style.order = i + 1;
				}
			}
		});

		this.DOM.modal.classList.add('is-visible');
	}

	onResetClick(e) {
		e.preventDefault();
		this.selectedEls = [];
		this.DOM.modal.classList.remove('is-visible');
		this.DOM.labelEls.forEach(el => el.classList.remove('is-selected'));
		this.DOM.submitEl.classList.toggle('g-btn--disabled', this.selectedEls.length !== this.maxResults);

		for (let res in this.results) {
			this.results[res] = 0;
		}

		setTimeout(() => {
			this.DOM.modalItems.forEach(el => {
				el.style.display = 'none';
				el.style.order = 0;
			});
		}, 500);
	}

	onCloseClick(e) {
		e.preventDefault();
		this.DOM.modal.classList.remove('is-visible');
		for (let result in this.results) {
			this.results[result] = 0;
		}
	}
}